import type { App_Users } from "@/src/gql/graphql";
import { EMPLOYEE_CONFIG } from "@/features/employees/components/EmployeeConfig";
import { EMPLOYEE_DETAIL_CONFIG } from "@/features/employees/components/EmployeeDetailConfig";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// EMPLOYEES ENTITY DEFINITION
// ============================================================================
// Employees map to app_users — WTC team members with CRM access.
// Column change: edit features/employees/components/EmployeeConfig.ts fields.
// ============================================================================

export const employeesEntity = defineEntity<App_Users>({
  tableConfig: EMPLOYEE_CONFIG,

  detailConfig: EMPLOYEE_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },
});
